import { Keys } from '@progress/kendo-react-common';
/**
 * @hidden
 */
export var NavigationAction;
(function (NavigationAction) {
    NavigationAction[NavigationAction["Toggle"] = 0] = "Toggle";
    NavigationAction[NavigationAction["Next"] = 1] = "Next";
    NavigationAction[NavigationAction["Previous"] = 2] = "Previous";
})(NavigationAction || (NavigationAction = {}));
/**
 * @hidden
 */
var NavigationService = /** @class */ (function () {
    function NavigationService(onNavigate) {
        this.onNavigate = onNavigate;
    }
    NavigationService.prototype.navigate = function (event, rtl) {
        var keyCode = event.keyCode;
        var action;
        switch (keyCode) {
            case Keys.left:
                action = !rtl ? NavigationAction.Previous : NavigationAction.Next;
                break;
            case Keys.up:
                action = NavigationAction.Previous;
                break;
            case Keys.right:
                action = !rtl ? NavigationAction.Next : NavigationAction.Previous;
                break;
            case Keys.down:
                action = NavigationAction.Next;
                break;
            case Keys.space:
                action = NavigationAction.Toggle;
                break;
            case Keys.enter:
                action = NavigationAction.Toggle;
                break;
            default:
                action = null;
                break;
        }
        if (action !== null) {
            event.preventDefault();
            this.onNavigate(action);
        }
    };
    return NavigationService;
}());
export { NavigationService };
//# sourceMappingURL=navigationService.js.map